import { withDependencies, named } from '@wix/thunderbolt-ioc'
import {
	BrowserWindow,
	BrowserWindowSymbol,
	EditorFeatureConfigSymbol,
	LayoutDoneServiceSymbol,
	ILayoutDoneService,
} from '@wix/thunderbolt-symbols'
import { ComponentPadding, IViewerManagerImplementor } from 'thunderbolt-viewer-manager-types'
import {
	name,
	MeasureMapApiSymbol,
	LayoutRegistrarSymbol,
	ScreenSizeApiSymbol,
	ComponentBoundingBoxApiSymbol,
	UpdateLayoutAndPushApiSymbol,
} from './symbols'
import type {
	ViewerManagerLayoutApiEditorConfig,
	ScreenSizeApi,
	MeasureMapApi,
	LayoutRegistrar,
	ICompBoundingBoxApi,
	IUpdateLayoutAndPushApi,
} from './types'
import { getFullId } from '@wix/thunderbolt-commons'

export const ViewerManagerLayoutApi = withDependencies(
	[
		named(EditorFeatureConfigSymbol, name),
		BrowserWindowSymbol,
		LayoutRegistrarSymbol,
		UpdateLayoutAndPushApiSymbol,
		MeasureMapApiSymbol,
		ScreenSizeApiSymbol,
		ComponentBoundingBoxApiSymbol,
		LayoutDoneServiceSymbol,
	],
	(
		config: ViewerManagerLayoutApiEditorConfig,
		window: NonNullable<BrowserWindow>,
		layoutRegistrar: LayoutRegistrar,
		updateLayoutAndPushApi: IUpdateLayoutAndPushApi,
		measureMapApi: MeasureMapApi,
		screenSizeApi: ScreenSizeApi,
		componentBoundingBoxApi: ICompBoundingBoxApi,
		layoutDoneService: ILayoutDoneService
	): IViewerManagerImplementor<'layout'> => {
		const layout = {
			...layoutRegistrar,
			...measureMapApi,
			...screenSizeApi,
			...componentBoundingBoxApi,
			...updateLayoutAndPushApi,
			getPadding: (compId: string) => {
				const node = document.querySelector(`.${getFullId(compId)}-container`)
				if (!node) {
					return {} as ComponentPadding
				}

				const style = window.getComputedStyle(node!)
				const pxToNumber = (pxSize: string) => Number(pxSize.replace('px', ''))

				return {
					left: pxToNumber(style.paddingLeft),
					right: pxToNumber(style.paddingRight),
					top: pxToNumber(style.paddingTop),
					bottom: pxToNumber(style.paddingBottom),
				}
			},
			getSiteX: () =>
				config.isMobileView ? 0 : Math.min(Math.floor((layout.getSiteWidth() - layout.getScreenWidth()) / 2)),
			getSiteWidth: () => config.siteWidth,
			isLayoutPending: layoutDoneService.isRenderPending,
			getLayoutMechanism: () => 'MESH',
		}

		return {
			layout,
		}
	}
)
